import React from 'react';

import { Skeleton } from 'components';
import { isSSRTheme } from 'utils';
import { ReactComponent as CriticalAlertsIcon } from 'assets/img/icons/new/critical_alerts_icon.svg';
import { ReactComponent as AnnouncementIcon } from 'assets/img/icons/new/announcement_icon.svg';
import { ReactComponent as AlertsIcon } from 'assets/img/icons/new/alerts_icon.svg';
import { ReactComponent as RabbitIcon } from 'assets/img/icons/new/rabbit_wander_img.svg';
import { ReactComponent as NotificationIcon } from 'assets/ss-icons/zero-state-icons/notification.svg';

export const COLOR_CODES = {
  critical: '#FEF0EE',
  announcement: '#E9F5F3',
  alert: '#F4F6F8',
  undefined: 'grey'
};

export const HOVER_COLOR_CODES = {
  critical: '#FFE9E6',
  announcement: '#E2F7F3',
  alert: '#EAEDF0',
  undefined: 'grey'
};

export const ICON_COLOR = {
  critical: '#e32707',
  announcement: '#0d6e3f',
  alert: '#45505B',
  undefined: 'grey'
};

/**
 * @type {Record<string, import("utils/types").ButtonVariant>}
 */
export const BUTTON_VARIANT = {
  critical: 'destructive',
  announcement: 'primary',
  alert: 'outline'
};

export const ICON_BG_COLOR_CODES = {
  critical: '#f8aca0cc',
  announcement: '#2BA38C1A',
  alert: '#DFE4E8',
  undefined: 'grey'
};

export const NOTIFICATION_ICON = {
  critical: <CriticalAlertsIcon />,
  announcement: <AnnouncementIcon />,
  alert: <AlertsIcon />,
  undefined: <AlertsIcon />
};

const Container = ({ children }) => (
  <div
    className="d-flex align-items-center justify-content-center h-75"
    style={{ color: '#637381' }}
  >
    <div className="text-center">
      {isSSRTheme() ? <NotificationIcon /> : <RabbitIcon />}
      <div className="mt-4">{children}</div>
    </div>
  </div>
);

export const AllReadComponent = () => (
  <Container>No unread notification</Container>
);

export const NoNotifications = () => <Container>No notifications</Container>;

export const NotificationError = () => (
  <Container>Oh no! there was an error in fetching notifications</Container>
);

export const NotificationSkeleteonLoader = () => (
  <Skeleton count={3} height="100px" className="rounded mb-4" />
);

export const EndOfNotifications = () => (
  <p className="text-center m-0">
    <b>All caught up! Stay tuned for new updates.</b>
  </p>
);
